import { useTheme } from '@/theme/ThemeProvider';
import type { ThemePref } from '@/theme/theme';
import { cx } from '@/lib/cx';
import { useT } from '@/i18n/LocaleProvider';
import type { UiKey } from '@/i18n/dictionary';
import styles from './AvatarMenu.module.css';

const OPTIONS: Array<{ value: ThemePref; label: UiKey; title: UiKey }> = [
  { value: 'dark', label: 'menu.themeDark', title: 'menu.themeDarkTitle' },
  { value: 'light', label: 'menu.themeLight', title: 'menu.themeLightTitle' },
  { value: 'system', label: 'menu.themeAuto', title: 'menu.themeAutoTitle' },
];

/** Сегментированный выбор темы Dark / Light / Auto в меню аватара. */
export function ThemeSegment() {
  const { pref, setPref } = useTheme();
  const t = useT();
  return (
    <span className={styles.segment} role="radiogroup" aria-label={t('menu.theme')}>
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={pref === option.value}
          title={t(option.title)}
          className={cx(styles.segmentButton, pref === option.value && styles.segmentActive)}
          onClick={() => setPref(option.value)}
        >
          {t(option.label)}
        </button>
      ))}
    </span>
  );
}
